import { styled } from '@mui/material';

const prefix = 'HusaHeader';
const classes = {
  root: `${prefix}-root`,
  appbar: `${prefix}-appbar`,
  toolbar: `${prefix}-toolbar`,
  links: `${prefix}-links`,
  logo: `${prefix}-logo`,
  flex: `${prefix}-flex`,
  kpi: `${prefix}-kpi`
};
const Root = styled('div')(({ theme }) => {
  return {
    [`&.${classes.root}`]: {
      flexGrow: 1,
      height: 64
    },
    [`& .${classes.appbar}`]: {
      backgroundColor: theme.palette.primary.dark,
      color: 'white'
    },
    [`& .${classes.toolbar}`]: {
      paddingLeft: theme.spacing(1)
    },
    [`& .${classes.logo}`]: {
      '& img': {
        height: 20,
        width: 105
      },
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      lineHeight: 0
    },
    [`& .${classes.links}`]: {
      marginLeft: theme.spacing(4),
      '& > a': {
        color: 'white',
        marginRight: theme.spacing(2)
      }
    },
    [`& .${classes.flex}`]: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'flex-end'
    },
    [`& .${classes.kpi}`]: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
});

export { Root, classes };
